<template>
  <!-- <div id="nav">
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </div> -->
  <div class="font-Prompt">
    <router-view />
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { useI18n } from "vue3-i18n";
import dayjs from "dayjs";
import "dayjs/locale/th";

export default defineComponent({
  setup() {
    const i18n = useI18n();
    const setLocale = (lang) => {
      i18n.setLocale(lang);
      dayjs.locale(lang);
    };
    return {
      setLocale,
    };
  },
  data() {
    return {
      lang: "en",
    };
  },
  mounted() {
    this.lang = this.$cookies.get("lang");
  },
  watch: {
    lang(value) {
      this.setLocale(value);
      this.$emit("changeLang", value);
    },
  },
});
</script>

<style>
#app {
  /* font-family: "Kanit", sans-serif; */
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* #nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
} */
</style>
